import { Switch, Route, Redirect } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";

import AuthRoutes from "../pages/auth/AuthRoutes";
import DashboardLayout from "../pages/dashboard/DashboardLayout";
import VideoPreviewPage from "../pages/preview/VideoPreviewPage";

const AppRoutes = () => {
  return (
    <Switch>
      {/* ============== PUBLIC ============== */}
      <Route path="/pages" component={AuthRoutes} />

      {/* ============== FULL-PAGE TOOLS (no sidebar) ============== */}
      <PrivateRoute path="/preview/:id" component={VideoPreviewPage} />

      {/* ============== PRIVATE APP SHELL ============== */}
      <PrivateRoute path="/" component={DashboardLayout} />

      {/* ============== FALLBACK ============== */}
      <Redirect to="/pages/login" />
    </Switch>
  );
};

export default AppRoutes;
